import React, { useEffect, useState } from 'react'
import SuccessStory from '../../CertificateVerification/SuccessStory'
import PlacementSuccessStory from '../../../components/PlacementSuccessStory'
import Faq from '../../CertificateVerification/Faq'
import NewRecognisedSection from '../../../components/NewRecognisedSection'
import ChooseNextCourse from './ChooseNextCourse'
import LcpJob from './LcpJob'
import ChooseNextJob from './ChooseNextJob'
import LcpCv from './LcpCv'
import ChooseNextCv from './ChooseNextCv'
import { useDispatch, useSelector } from 'react-redux'
import { capitalizeWords } from '../../../utils/subscription'
import { setOnboardingPhase } from '../../../redux/actions/authentication'
import CertificateUnlockFeature from '../CertificateUnlockFeature'
import ProjectShowcaseFeature from '../ProjectShowcaseFeature'
import CourseAccessFeature from '../CourseAccessFeature'
import NinjaBotFeature from '../NinjaBotFeature'
import { Mixpanel } from '../../../config/Mixpanel'
import Constants from '../../../common/constants'
import { setActivationPhase } from '../../../redux/actions/contentPayer'
import { SET_IS_ACTIVATION } from '../../../redux/actions/types'
import OnBoardingFaq from '../onBoardingFaq'

const Cv = ({razorpayMainHandler , handleOnboardingCompletion , handleOnboardingCompletionWithoutRedirection}) => {
    const [swiperInstance, setSwiperInstance] = useState(null)
    const firstName = useSelector((store) => store?.profileDetails?.first_name) || "";
    const goal = useSelector((store) => store?.onBoarding?.goal) || "";
    const dispatch = useDispatch();

    const handleRedirectionToResume = () => {
        window.location.href = `https://resume.learntube.ai`       
    }

    useEffect(() => {
        Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_CV_PAGE_LOADED);
    }, []);
    
  return (
    <div className='w-full'>
        <div className='font-semibold leading-[130%] text-[28px] text-center text-[#DED996] tracking-[-0.1]'>{firstName}, Boost Your Visibility & Land 3x More Interviews Job With Expert-Reviewed Profile</div>
        <div className='mt-8'>
            <LcpCv razorpayMainHandler={razorpayMainHandler} handleOnboardingCompletion={handleOnboardingCompletion} handleOnboardingCompletionWithoutRedirection={handleOnboardingCompletionWithoutRedirection} handleRedirectionToResume={handleRedirectionToResume} />
        </div>
        <div className='mt-12 text-center'>
            <div className='text-[16px]  text-white/50'>What Your Career Could Look Like</div>
            <div className='text-[24px] font-semibold text-white leading-[130%]'>In Just 8 Weeks, {firstName}!</div>
            <img alt="" className='w-full mt-4' src="https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/Frame%20427322063%20(2).webp"/>
        </div>
        <div className='mt-10'>
            <NewRecognisedSection swiperInstance={swiperInstance} setSwiperInstance={setSwiperInstance}/>
        </div>
        <div className='mt-12 text-center'>
            <div className='text-[16px]  text-white/50'>What You’ll Get</div>
            <div className='text-[24px] font-semibold text-white leading-[130%]'>Everything To Get Placed As A {capitalizeWords(goal)}</div>
            <div className='mt-4 space w-full flex flex-col items-center justify-center gap-2 md:gap-4'>
                <CertificateUnlockFeature/>
                <ProjectShowcaseFeature stepNumber={2}/>
                <CourseAccessFeature stepNumber={3}/>
                <NinjaBotFeature stepNumber={4}/>
            </div>
            <div className='w-full text-center font-semibold text-[#70AEFF] text-[14px] mt-4'>& Many More...</div>

        </div>
        <div className='mt-12'>
            <ChooseNextCv razorpayMainHandler={razorpayMainHandler} handleRedirectionToResume={handleRedirectionToResume}/>
        </div>
        <div className='mt-12 w-full flex flex-col items-center justify-center text-center'>
            <div className='text-[16px]  text-white/50'>Success Stories</div>
            <div className='text-[24px] font-semibold text-white mb-4 leading-[130%]'>Real Learners, Real Outcomes</div>
            <PlacementSuccessStory/>
        </div>
        <div className='mt-12'>
            <SuccessStory/>
        </div>
        <div className="mt-12 mb-4 text-center text-[24px] font-semibold text-white">
          Frequently{" "}
          <span className=""> Asked </span>{" "}
          Questions
        </div>
       <OnBoardingFaq/>

    </div>
  )
}

export default Cv